import { Link } from 'react-router-dom';
import { Upload, MessageCircle, Zap } from 'lucide-react';

const CTASection = ({ onGetStarted }) => {
  return (
    <section className="relative py-24 bg-[#0A0A0A] overflow-hidden">
      {/* Background glow */}
      <div className="absolute inset-0 hero-glow opacity-50" />
      <div className="absolute inset-0 grid-bg opacity-10" />
      
      <div className="container mx-auto px-6 md:px-12 lg:px-24 relative z-10 text-center">
        {/* Label */}
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#1A1A1A] border border-white/10 mb-6">
          <Zap className="w-4 h-4 text-[#00F0FF]" />
          <span className="text-xs font-bold tracking-[0.2em] uppercase text-[#888]">
            Start Now
          </span>
        </div>
        
        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight uppercase mb-6">
          Ready to
          <span className="text-[#00F0FF]"> Get Started?</span>
        </h2>
        
        <p className="text-[#888] text-lg max-w-xl mx-auto mb-10 leading-relaxed">
          Upload your ECU file now and receive your professionally modified file within 20-60 minutes.
        </p>
        
        <div className="flex flex-wrap justify-center gap-4">
          <button 
            onClick={onGetStarted}
            className="btn-skew group relative overflow-hidden bg-[#00F0FF] text-black font-bold uppercase tracking-wider px-10 py-5 text-lg hover:bg-white hover:shadow-[0_0_40px_rgba(0,240,255,0.6)] transition-all duration-300"
            data-testid="cta-upload-btn"
          >
            <span className="relative z-10 flex items-center gap-2">
              <Upload className="w-6 h-6" />
              Upload ECU File
            </span>
          </button>
          <Link 
            to="/contact"
            className="btn-skew group relative overflow-hidden border border-white/20 text-white font-bold uppercase tracking-wider px-10 py-5 text-lg hover:border-[#00F0FF] hover:text-[#00F0FF] transition-all duration-300"
          >
            <span className="relative z-10 flex items-center gap-2">
              <MessageCircle className="w-6 h-6" />
              Contact Us
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
